import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  // console.log("Product---->",product);
  return (
    <Card className="card">
      <CardMedia
        component="img"
        // fullWidth
        image={product.image}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {product.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ${product.cost}
        </Typography>
        <Rating value={product.rating} readOnly />
      </CardContent>
      <CardActions className="card-actions">
        <Button
          startIcon={<AddShoppingCartOutlined />}
          variant="contained"
          fullWidth
          className="card-button"
          onClick={handleAddToCart}
        >
          ADD TO CART
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
